import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  IconButton,
  Step,
  StepLabel,
  TableCell,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import CandidateSupportIco from "../../../../assets/icons/CandidateSupportIco";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import PageStepperDefaultIco from "../../../../assets/icons/PageStepperDefaultIco";
import ReportBugIco from "../../../../assets/icons/ReportBugIco";
import StepperActiveIco from "../../../../assets/icons/StepperActiveIco";
import StepperInprogressIco from "../../../../assets/icons/StepperInprogressIco";
import SupportIco from "../../../../assets/icons/SupportIco";
import SnackBar from "../../../../component/SnackBar";
import {
  ChatBotCall,
  ChatBotGetCall,
  SupportCall,
  SupportGetCall,
} from "../../../../redux/action/ChatBot";
import { FeedBackButton } from "../../../../redux/action/Feedback";
import {
  CreateJobDelete,
  CreateJobList,
  JobClassificationList,
  JobIndustryList,
  JobJDSubmit,
} from "../../../../redux/action/Job";
import { TeamGetCall } from "../../../../redux/action/UserManagement";
import { MinimizeIcon } from "../../../../redux/action/Login";
import CommonTable from "../../../candidates/Table";
import ChatBotLabelText from "../../../chat-bot/ChatBotLabelText";
import SideBarChatBot from "../../../chat-bot/SIdeBarChatBot";
import { CustomDiv } from "../../../chat-bot/style";
import {
  CommonGrid2,
  DotColor,
  StatusChange,
} from "../../../common-components/StyledComponents";
import { StepperStyle } from "../../../matches/quick-match/style";
import InputJobData from "../components/InputJobData";
import ReviewJobPost from "../components/ReviewJobPost";
import SkillDeleteDialog from "../../../common-components/DeleteDialog";
import { handleDataTime } from "../../../common-components/JobFunction";

const CreateNewJob = () => {
  const [uploadJobData, setUploadJobData] = useState({});
  const [deleteTableRow, setDeleteTableRow] = useState({
    open: false,
    loading: false,
    content: "",
    id: "",
  });
  const [createJobList, setCreateJobList] = useState({
    data: [],
    currentPage: 1,
    totalPage: "",
    loading: true,
  });
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(useLocation().search);
  const valueStatus = query.get("value");
  const limit = 5;
  const headerData = [
    { name: "Req ID", direction: "asc", sort: false, minWidth: "120px" },
    { name: "Title", direction: "asc", sort: false },
    { name: "Status", direction: "asc", sort: false },
    {
      name: "Compensation (Hourly / Annual)",
      direction: "asc",
      sort: false,
      minWidth: "200px",
    },
    { name: "Client", direction: "asc", sort: false },
    { name: "Created", direction: "asc", sort: false },
    {},
  ];
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [chatBotData, setChatBotData] = useState({
    message: [
      { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
    ],
    value: "",
    loader: false,
    pageLoader: false,
    arrow: true,
    bubble: [],
    bubbleCondition: false,
    selectedValue: "Support",
    expandDrawer: false,
  });
  const [isBottomVisible, setIsBottomVisible] = useState(true);
  const [tabData, setTabData] = useState([
    {
      label: "Input Job Data",
      status: "In Progress",
    },
    {
      label: "Scoring",
      status: "Pending",
    },
    {
      label: "Review Job Post",
      status: "Pending",
    },
  ]);
  const [value, setValue] = React.useState(0);
  const buttonSupport = [
    ...(value === 2
      ? [
          {
            name: "Job",
            icon: <CandidateSupportIco />,
          },
          {
            name: "Support",
            icon: <SupportIco />,
          },
        ]
      : [
          {
            name: "Support",
            icon: <SupportIco />,
          },
        ]),
    {
      name: "Report Bug",
      icon: <ReportBugIco />,
    },
  ];

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [list, setList] = useState({
    industry: [],
    classification: [],
    disabled: false,
    loading: true,
    buttonLoading: false,
  });
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [userData, setUserData] = useState({
    account_executive: { username: "", id: "" },
    job_owner: { username: "", id: "" },
    user_list: [],
    date_time: null,
  });

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const fetchUsersList = async () => {
    try {
      const usersList = await TeamGetCall();
      setUserData((prev) => ({
        ...prev,
        user_list: usersList?.data || [],
      }));
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleMenuItem = (value, name) => {
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const uploadFile = async (getName, setCandidateFiles, payload) => {
    setTabData((prev) =>
      prev.map((tab, index) =>
        index < 1
          ? { ...tab, status: "Completed" }
          : index === 1
          ? { ...tab, status: "In Progress" }
          : tab
      )
    );
    setValue(1);
    if (
      localStorageData?.organization === "Demo" &&
      localStorageData?.role === "Demo"
    ) {
      const interval = setInterval(() => {
        setList((f) => {
          const updatedProgress = f.progress + 10;
          const isComplete = updatedProgress >= 100;

          if (isComplete) {
            clearInterval(interval);

            setTimeout(() => {
              setUploadJobData(localStorageData?.demo_config?.demo_job);
              setTabData((prev) =>
                prev.map((tab, index) =>
                  index <= 2 ? { ...tab, status: "Completed" } : tab
                )
              );

              setValue(2);
              setSnackbarState({
                open: true,
                message: "Update Successfully",
                severity: "success",
              });
            }, 500);

            return { ...f, progress: 100, buffer: 100 };
          }

          return {
            ...f,
            progress: updatedProgress,
            buffer: updatedProgress,
            visible: false,
            delete: false,
          };
        });
      }, 300);

      setTimeout(() => clearInterval(interval), 4000);
    } else {
      try {
        const response = await JobJDSubmit(payload);
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          let boundaryIndex;
          while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
            const jsonString = buffer.slice(0, boundaryIndex + 1);
            buffer = buffer.slice(boundaryIndex + 1);
            const jsonResponse = JSON.parse(jsonString);
            try {
              processJsonResponse(jsonResponse, getName, setCandidateFiles);
            } catch (e) {
              setTabData((prev) =>
                prev.map((tab, index) =>
                  index === 0
                    ? { ...tab, status: "Inprogress" }
                    : index === 1
                    ? { ...tab, status: "Pending" }
                    : tab
                )
              );
              setValue(0);

              setSnackbarState({
                open: true,
                message: "Error parsing JSON",
                severity: "error",
              });
            }
          }
        }

        if (buffer) {
          const jsonResponse = JSON.parse(buffer);
          try {
            processJsonResponse(jsonResponse, getName, setCandidateFiles);
          } catch (e) {
            setTabData((prev) =>
              prev.map((tab, index) =>
                index === 0
                  ? { ...tab, status: "Inprogress" }
                  : index === 1
                  ? { ...tab, status: "Pending" }
                  : tab
              )
            );
            setValue(0);

            setList((prev) => ({
              ...prev,
              buttonLoading: false,
              disabled: false,
              loading: false,
              visible: true,
              message: jsonResponse.message,
            }));

            setSnackbarState({
              open: true,
              message: "Error parsing final JSON chunk",
              severity: "error",
            });
          }
        }
      } catch (error) {
        setTabData((prev) =>
          prev.map((tab, index) =>
            index === 0
              ? { ...tab, status: "Inprogress" }
              : index === 1
              ? { ...tab, status: "Pending" }
              : tab
          )
        );
        setValue(0);

        setList((prev) => ({
          ...prev,
          buttonLoading: false,
          disabled: false,
          loading: false,
          visible: true,
          message: "Error during the request",
        }));

        setSnackbarState({
          open: true,
          message: "Error during the request",
          severity: "error",
        });
      }
    }
  };

  const processJsonResponse = (jsonResponse, getName, setCandidateFiles) => {
    const { success, data, message } = jsonResponse;
    // setUploadJobData(jsonResponse);
    if (success && data?.percent !== undefined) {
      setList((prevFiles) => ({
        ...prevFiles,
        progress: data.percent,
        buffer: data.percent,
        visible: false,
        progress_message: data.progress_message,
      }));
    } else if (data?.id) {
      setUploadJobData(data?.id);

      setSnackbarState({
        open: true,
        message: message,
        severity: "success",
      });

      setTabData((prev) =>
        prev.map((tab, index) =>
          index <= 1
            ? { ...tab, status: "Completed" }
            : { ...tab, status: "In Progress" }
        )
      );
      setValue(2);
    } else if (!success) {
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "Inprogress" }
            : index === 1
            ? { ...tab, status: "Pending" }
            : tab
        )
      );
      setValue(0);
      setList((prev) => ({
        ...prev,
        buttonLoading: false,
        disabled: false,
        loading: false,
        visible: true,
        message: message,
      }));
    }
  };

  const JDInitialValues = {
    location: "",
    industry: "",
    occupational_classification: "",
    sample_jd_text: "",
  };

  const validationSchemaJD = Yup.object().shape({
    sample_jd_text: Yup.string().required("Description is required"),
  });

  const handleCallJobDescription = async () => {
    try {
      setList((prev) => ({
        ...prev,
        industry: [],
        disabled: true,
        loading: true,
        classification: [],
      }));

      const listData = await JobIndustryList();
      const classification = await JobClassificationList();

      setList((prev) => ({
        ...prev,
        industry: listData,
        classification: classification,
        disabled: false,
        loading: false,
      }));
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setList((prev) => ({
        ...prev,
        buttonLoading: false,
        disabled: false,
        loading: false,
      }));
    }
  };

  const handleJDSubmit = async (values) => {
    setList((prev) => ({
      ...prev,
      loading: false,
      disabled: true,
      buttonLoading: true,
      progress: 0,
      buffer: 0,
    }));

    // Include account_executive and job_owner IDs in the payload
    const payload = {
      ...values,
      account_executive: userData?.account_executive?.id || "",
      job_owner: userData?.job_owner?.id || "",
      submission_deadline: userData?.date_time
        ? new Date(
            userData.date_time.format("YYYY-MM-DDTHH:mm:ss")
          ).toISOString()
        : "",
    };
    uploadFile("JDNext", setList, payload);
  };

  const handlePageChange = (page) => {
    setCreateJobList((prev) => ({
      ...prev,
      currentPage: page,
    }));
    fetchJobsList(limit, (page - 1) * limit);
  };

  const fetchJobsList = async (limit, offset) => {
    setCreateJobList((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      let params = {
        limit: limit,
        offset: offset,
        status: "Draft",
        jd_type: "Create",
      };
      const response = await CreateJobList(params);
      const data = response.data;
      setCreateJobList((prev) => ({
        ...prev,
        data: data?.results || [],
        totalPage: data?.total_pages,
        loading: false,
      }));
    } catch (err) {
      setCreateJobList((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  useEffect(() => {
    if (value === 0) {
      const handleCall = async () => {
        try {
          setList((prev) => ({
            ...prev,
            loading: true,
          }));
          await handleCallJobDescription();
          await fetchJobsList(limit, (createJobList.currentPage - 1) * limit);
          await fetchUsersList();
          setList((prev) => ({
            ...prev,
            loading: false,
          }));
        } catch (error) {
          setList((prev) => ({
            ...prev,
            loading: false,
          }));
          setSnackbarState({
            open: true,
            message: error.message,
            severity: "error",
          });
        }
      };

      handleCall();
    }
  }, [value]);

  useEffect(() => {
    if (valueStatus === null) {
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "In Progress" }
            : { ...tab, status: "Pending" }
        )
      );
      setList({
        industry: [],
        classification: [],
        disabled: false,
        loading: true,
        buttonLoading: false,
      });
      setValue(0);
    }
  }, [location]);

  const handleIconClick = (row) => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: "Job",
    }));
    setTabData((prev) =>
      prev.map((tab, index) =>
        index <= 1
          ? { ...tab, status: "Completed" }
          : { ...tab, status: "In Progress" }
      )
    );
    setUploadJobData(row?.id);
    setTimeout(() => {
      navigate(`/create-new-job?value=${2}`);
      setValue(2);
    }, 0);
  };

  const handleTableBodyData = (row, index) => {
    if (!row) return null;

    const handleDeleteClick = (e, row) => {
      e.stopPropagation();
      setDeleteTableRow((prev) => ({
        ...prev,
        open: true,
        content: row.job_title,
        id: row.id,
      }));
    };
    return (
      <>
        <TableCell>{row.req_id || "-"}</TableCell>
        <TableCell>{row.job_title || "-"}</TableCell>

        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.status === "Active"
                  ? "green"
                  : row.status === "Hold"
                  ? "orange"
                  : "#667085"
              }
            />
            {row.status || "-"}
          </StatusChange>
        </TableCell>
        <TableCell>{row.pay_rate || "-"}</TableCell>
        <TableCell>{row.client || "-"}</TableCell>
        <TableCell>
          {row.created_at ? new Date(row.created_at).toLocaleDateString() : "-"}
        </TableCell>

        <TableCell>
          <CommonGrid2 alignItems={"center"} gap={"0.8rem"} display={"flex"}>
            <VisibilityOutlinedIcon
              onClick={() => (list.disabled ? {} : handleIconClick(row))}
              style={{
                cursor: list.disabled ? "auto" : "pointer",
                fontSize: "21px",
                opacity: list.disabled ? 0.4 : 1,
              }}
            />
            <IconButton
              onClick={(e) => handleDeleteClick(e, row)}
              disabled={list.disabled}
              style={{ opacity: list.disabled ? 0.4 : 1 }}
            >
              <DeleteIco strokeWidth={2} />
            </IconButton>
          </CommonGrid2>
        </TableCell>
      </>
    );
  };

  const handleDeleteTableClose = () => {
    setDeleteTableRow({
      open: false,
      loading: false,
      content: "",
      id: "",
    });
  };

  const handleDeleteRow = async () => {
    try {
      setDeleteTableRow((prev) => ({
        ...prev,
        loading: true,
      }));

      let data = await CreateJobDelete(deleteTableRow.id);
      setCreateJobList((prev) => ({
        ...prev,
        currentPage:
          createJobList.currentPage === 1
            ? 1
            : createJobList.data?.length === 1
            ? createJobList.currentPage - 1
            : createJobList.currentPage,
      }));
      let page =
        createJobList.currentPage === 1
          ? 1
          : createJobList.data?.length === 1
          ? createJobList.currentPage - 1
          : createJobList.currentPage;

      fetchJobsList(limit, (page - 1) * limit);

      setSnackbarState({
        open: true,
        message: data?.message,
        severity: "success",
      });
      handleDeleteTableClose();
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setDeleteTableRow((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const QontoStepIcon = (props) => {
    const { active, completed } = props;

    if (completed) {
      return <StepperActiveIco size={"28"} />;
    }
    if (active) {
      return <StepperInprogressIco size={"28"} />;
    } else return <PageStepperDefaultIco size={"28"} />;
  };

  useEffect(() => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: value === 2 ? "Job" : "Support",
    }));

    if (
      (value === 0 || value === 1) &&
      chatBotData.selectedValue === "Support"
    ) {
      handleSupportCall();
    }
    if (value === 2) {
      handleChatBotCandidateCall();
    }
  }, [value]);

  const handleSupportCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
      message: [
        { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
      ],
    }));
    try {
      const data = await SupportGetCall(localStorageData?.user_id);
      const messages = [];
      data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [prev.message[0], ...messages],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleButtonSupport = (name) => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: name === "Report Bug" ? prev.selectedValue : name,
    }));
    if (name === "Report Bug") {
      dispatch(FeedBackButton(true));
    } else if (name === "Support") {
      handleSupportCall();
    } else if (name === "Job") {
      handleChatBotCandidateCall();
    }
  };

  const handleToggleDrawer = () => {
    if (!open) {
      if (value === 2) {
        handleChatBotCandidateCall();
      } else {
        handleSupportCall();
      }
    }
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: value === 2 ? "Job" : "Support",
      expandDrawer: false,
    }));
    setOpen((prev) => {
      const newState = !prev;
      dispatch(MinimizeIcon(prev, newState));
      return newState;
    });
  };

  const handleChatBotCandidateCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
      message: [
        { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
      ],
    }));
    try {
      const data = await ChatBotGetCall(uploadJobData);
      const messages = [];
      data?.data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [prev.message[0], ...messages],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;
    let payload;
    if (chatBotData.selectedValue === "Job") {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "match_data",
          job_data_id: uploadJobData,
        },
      };
    } else {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "user_manuals",
          user_id: localStorageData?.user_id,
        },
      };
    }

    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],

      loader: true,
      value: "",
    }));

    try {
      let data;
      if (chatBotData.selectedValue === "Job") {
        data = await dispatch(ChatBotCall(payload));
      } else {
        data = await SupportCall(payload);
      }
      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleChatBotChange = (event) => {
    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleUpArrow = (condition) => {
    setChatBotData((prev) => ({
      ...prev,
      arrow: condition === "up" ? false : true,
    }));
  };

  const handleStepCompleted = () => {
    setTabData((prev) =>
      prev.map((tab, index) =>
        index <= 2 ? { ...tab, status: "Completed" } : tab
      )
    );
  };

  const handleExpandDrawer = () => {
    setChatBotData((prev) => ({
      ...prev,
      expandDrawer: !prev.expandDrawer,
    }));
  };

  return (
    <CustomDiv
      background="#F6F8FB"
      height={"100vh"}
      overflowY="auto"
      display="flex"
    >
      <CommonGrid2
        width={
          open
            ? `calc(100% - ${chatBotData.expandDrawer ? "450px" : "350px"})`
            : "100%"
        }
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        borderRadius={"10px"}
        height={"fit-content"}
        padding={"1rem"}
        margin={"1.35rem 1rem 1.35rem 1.35rem"}
        position={"relative"}
        sx={{
          transition: theme.transitions.create(["width"], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
          }),
        }}
      >
        <Typography variant="h2">Create Job</Typography>

        <StepperStyle
          activeStep={value}
          margin={value === 2 && "1rem  0px 2rem"}
        >
          {tabData.map((step, index) => (
            <Step
              key={step.label}
              style={{
                padding:
                  index === 2
                    ? "0px 0px 0px 1.2rem"
                    : index === 0
                    ? "0px 1.2rem 0px 0px"
                    : "0px 1.2rem",
              }}
            >
              <StepLabel StepIconComponent={QontoStepIcon}>
                <CommonGrid2
                  display="flex"
                  flexDirection="column"
                  gap="5px"
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography variant="span" color="#344054" fontWeight={600}>
                    {step.label}
                  </Typography>

                  <Typography
                    variant="span"
                    color={
                      step.status === "Completed"
                        ? "#17B26A"
                        : step.status === "In Progress"
                        ? "#7F56D9"
                        : "#5B738B"
                    }
                  >
                    {step.status}
                  </Typography>
                </CommonGrid2>
              </StepLabel>
            </Step>
          ))}
        </StepperStyle>

        {(value === 0 || value === 1) && (
          <>
            <InputJobData
              inputJdView={2}
              list={list}
              JDInitialValues={JDInitialValues}
              validationSchemaJD={validationSchemaJD}
              handleJDSubmit={handleJDSubmit}
              userData={userData}
              handleMenuItem={handleMenuItem}
              handleDataTime={(newValue) =>
                handleDataTime(newValue, setUserData)
              }
            />
            <CommonTable
              data={createJobList.data}
              columns={headerData}
              onSortChange={(col) => console.log("Sort by", col)}
              handleTableBodyData={handleTableBodyData}
              paginationProps={{
                count: createJobList.totalPage,
                page: createJobList.currentPage,
                onPageChange: (page) => handlePageChange(page),
              }}
              withPagination={true}
              loading={createJobList.loading}
              customStyle={{
                "& .MuiTableRow-root": {
                  cursor: list.disabled ? "auto" : "pointer",
                },
                "& .MuiTableRow-head": {
                  cursor: "auto",
                },
              }}
              handleRowClick={list.disabled ? {} : handleIconClick}
            />
          </>
        )}
        {value === 2 && (
          <ReviewJobPost
            createId={uploadJobData}
            handleStepCompleted={handleStepCompleted}
          />
        )}
      </CommonGrid2>

      <CommonGrid2
        sx={{
          transition: theme.transitions.create(["width"], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
          }),
        }}
        width={open ? (chatBotData.expandDrawer ? "450px" : "350px") : "0px"}
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        top={"0px"}
        position={"sticky"}
        right={"0"}
        height={"100%"}
        overflowY={"auto"}
        scrollStyle
        scrollBar="5px"
      >
        <CommonGrid2
          padding={"0rem 1rem 1rem"}
          height={"100%"}
          justifyContent={"space-between"}
          display={"flex"}
          flexDirection={"column"}
        >
          <SideBarChatBot
            handleToggleDrawer={handleToggleDrawer}
            jobId={uploadJobData}
            // height={minimizeScreen}
            chatBotData={chatBotData}
            // handleChatBotFetchData={handleChatBotFetchData}
            handleSendMessage={handleSendMessage}
            handleChatBotChange={handleChatBotChange}
            isBottomVisible={isBottomVisible}
            setIsBottomVisible={setIsBottomVisible}
            handleUpArrow={handleUpArrow}
            userName={localStorageData?.username}
            buttonSupport={buttonSupport}
            handleButtonSupport={handleButtonSupport}
            handleExpandDrawer={handleExpandDrawer}
          />
        </CommonGrid2>
      </CommonGrid2>

      <SkillDeleteDialog
        deleteDialog={deleteTableRow.open}
        handleDeleteDialogClose={handleDeleteTableClose}
        handleDeleteSkill={handleDeleteRow}
        buttonLoading={deleteTableRow.loading}
        title={"Delete Job"}
        content={deleteTableRow.content}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />

      {!open && (
        <ChatBotLabelText
          title={value === 2 ? "My name is Hailey. Ask me about this Job" : ""}
          chatBotData={chatBotData}
          handleToggleDrawer={handleToggleDrawer}
        />
      )}
    </CustomDiv>
  );
};
export default CreateNewJob;
